import { styled } from '@mui/material/styles';
export const ListHeader = styled('div') `
	margin-right: 15px;
	margin-left: 15px;
	margin-top: 5px;
`;
